


















import { Component, Vue } from 'vue-property-decorator';
import deck from '@/store/modules/deck';

@Component
export default class SlideNav extends Vue {
  get slides() {
    return deck.Slides;
  }

  get currentSlide() {
    return deck.nav.currentSlide;
  }

  chooseSlide(value: string) {
      const page = value;
      if (page === 'first') {
          deck.setCurrentSlide(1);
      }
      if (page === 'previous') {
          if (this.currentSlide > 1) {
              deck.setCurrentSlide(this.currentSlide - 1);
          }
      }
      if (page === 'next') {
          if (this.currentSlide < this.slides.length) {
              deck.setCurrentSlide(this.currentSlide + 1);
          }
      }
      if (page === 'last') {
          deck.setCurrentSlide(this.slides.length);
      }
  }
}

